/**
 * Feature-scoped JSDoc types for the dashboard module.
 */

/**
 * Company locale and currency preferences.
 *
 * Completeness is country + currency only. Language is not required to
 * finish setup. When language is blank, setup PATCH defaults it to "en"
 * without overwriting a language already saved on the server.
 *
 * @typedef {Object} CompanyPreferences
 * @property {string} country ISO 3166-1 alpha-2 country code (e.g. "IN")
 * @property {string} currency ISO 4217 currency code (e.g. "INR")
 * @property {string} language ISO 639-1 language code (e.g. "en")
 */

/** @type {CompanyPreferences} */
export const EMPTY_COMPANY_PREFERENCES = {
  country: '',
  currency: '',
  language: '',
};

/**
 * Currency option from GET /v1/companies/currencies/.
 *
 * @typedef {Object} CompanyCurrency
 * @property {string} code ISO 4217 currency code (e.g. "INR")
 * @property {string} name Display name (e.g. "Indian Rupee")
 * @property {string} [symbol] Currency symbol (e.g. "₹")
 */
